<template>
    <page>
        <module>
            <view-list ref="view" :work-type="132" :view-config="saasInfo.viewmanage" :summed="false">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="商户">
                            <c-select name="saas_id" async @search="searchSaas"></c-select>
                        </m-search-item>
                        <m-search-item label="完成时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
<!--                        <m-search-item label="商户名称">-->
<!--                            <c-input name="saas_name"></c-input>-->
<!--                        </m-search-item>-->
                        <m-search-item label="扣减渠道">
                            <c-select name="channel_id" async @search="searchChannel"></c-select>
                        </m-search-item>
                        <m-search-item label="积分状态">
                            <c-select name="points_status" :options="statusOptions"></c-select>
                        </m-search-item>
                    </m-search>
                    <div class="summary-tip">未选日期时统计近30天。</div>
                </template>

                <template #operate>
                    <c-button v-if="auth('p_finance_saas_points_summary_export')"
                              prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <template #points_status="{data}">
                    <span :style="{color: {'充足': 'green', '正常': 'black', '不足': 'red'}[data.points_status]}">{{ data.points_status }}</span>
                </template>
                <template #warning_days="{data}">
                    {{ data.warning_days == null ? '—' : data.warning_days }}
                </template>
                <template #channel_details="{data}">
                    <span class="channel-details">{{ data.channel_details || '—' }}</span>
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'p_finance_saas_points_summary',

    data() {
        return {
            statusOptions: ['充足', '正常', '不足'].map(value => ({name: value, value}))
        }
    },

    computed: {
        ...mapState(['saasInfo'])
    },

    methods: {
        searchSaas(keyword, resolve) {
            this.request({
                url: '/sys_saas/options',
                data: {keyword},
                success: resolve
            })
        },

        searchChannel(keyword, resolve) {
            this.request({
                url: '/sale/product/channel/options',
                data: {keyword},
                success: data => {
                    resolve([{name: '其他/未关联渠道', value: -1}].concat(
                        (data || []).map(item => ({name: item.channel_name, value: item.channel_id}))
                    ))
                }
            })
        }
    }
}
</script>

<style scoped>
.summary-tip {
    padding: 8px 16px;
    color: #888;
}

.channel-details {
    white-space: normal;
}
</style>
